module.exports = __webpack_public_path__ + "static/media/PKST.426474a9.svg";